import styled from 'styled-components';
import {
  TripOptions as BaseTripOptions,
  Styled as TripFormClasses,
  TripOptionsStyled as TripOptionsClasses,
} from '@opentripplanner/trip-form';
import BaseInfoIcon from '#/shared/components/GeneratedIcons/trimet/Info';
import { InverseClearButton } from '#/shared/components/Styled';
import { GTM_DATA_ATTRIBUTE } from '#/shared/constants';
import GTM_HANDLES from '#/shared/gtm-handles';
import CaretDown from '#/images/svg/caret-down.svg';
import Button from '#/shared/components/Buttons';
import { focusCssRule } from '#/shared/css/focus';

export const rentalCompanyIconStyles = {
  fill: '#000',
  width: 70,
};

export const ModeSelectorLayout = styled.div`
  background-color: ${props => props.theme.tripModeBgColor};
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;

  .indiana-scroll-container {
    background-color: ${props => props.theme.inverseBackgroundColor2};
    > button:first-child svg {
      width: 3.5em;
      height: 3.5em;
      font-size: initial;
    }
    > button {
      min-width: 80px;

      ${focusCssRule({ type: 'inset' })}
    }
  }
`;

// TODO: some of these styling overrides come from examples put together
//  by otp-ui devs and need to be refined to better align with this app
export const TripOptions = styled(BaseTripOptions)`
  min-height: initial;

  ${TripFormClasses.SettingLabel} {
    padding-top: 8px;
    color: ${({ theme }) => theme.primaryFontColorReverse};
    font-weight: 400;
  }

  ${TripFormClasses.DropdownSelector} {
    select {
      appearance: none;
      background-image: url('${CaretDown}');
      background-position: right center;
      background-repeat: no-repeat;
      background-color: transparent;

      font-size: inherit;
      font-family: inherit;
      font-weight: inherit;
      margin-bottom: 15px;

      border-radius: 0;
      padding: 6px 12px;
      border: none;
      border-bottom: 1px solid ${({ theme }) => theme.primaryFontColorReverse};
      height: 34px;
      line-height: 1.42857;
      color: ${({ theme }) => theme.primaryFontColorReverse};

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      option {
        color: ${({ theme }) => theme.primaryFontColor};
      }
    }
  }

  ${TripOptionsClasses.OverlayHeader} {
    margin-bottom: 0.25em;
  }

  ${TripOptionsClasses.OverlayContainer} {
    p {
      margin-bottom: 1em;
    }
  }
`;

export const PlanTripButton = styled(Button)`
  width: 250px;
`;

export const SaveSettingsButton = styled(InverseClearButton).attrs({
  [GTM_DATA_ATTRIBUTE]: GTM_HANDLES.shared.plannerOptionsSaveSettingsButton,
})`
  border: 2px solid ${props => props.theme.borderColor};
  border-radius: 5px;
  padding: 5px;
  font-size: 1.1em;
  width: 100%;
  max-width: 250px;
  text-align: center;
  @media (any-hover: hover) {
    &:hover {
      background-color: ${props => props.theme.hoverColorInverted};
    }
  }
  &:focus,
  &:active {
    background-color: transparent;
  }
`;

export const ModeSelectorButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > button {
    margin-bottom: 10px;
  }
`;

export const InfoIcon = styled(BaseInfoIcon).attrs(props => ({
  fill: props.theme.secondaryBackgroundColor,
  height: 14,
  width: 14,
}))``;
